<template>
  <div class="list-item">
    <v-list-item-avatar v-if="!isMobile">
      <v-icon>mdi-menu</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex">
            <span class="font-weight-bold">{{ page.name }}</span>
          </div>
        </div>
        <div class="d-flex">
          <EditMicrositePageAction
            :micrositeId="micrositeId"
            :micrositePage="page"
            :displayOrder="displayOrder"
          />
          <DeleteMicrositePageAction :micrositeId="micrositeId" :id="page.id" />
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import EditMicrositePageAction from "@/views/settings/components/microsites/components/actions/EditMicrositePageAction";
import DeleteMicrositePageAction from "@/views/settings/components/microsites/components/actions/DeleteMicrositePageAction";

export default {
  props: {
    page: {
      type: Object,
      required: true
    },
    micrositeId: String,
    displayOrder: Number
  },
  components: {
    EditMicrositePageAction,
    DeleteMicrositePageAction
  }
};
</script>
